import { HTMLAttributes, useMemo, useState } from 'react';
import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton, styled } from '@mui/material';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export type CustomDialogProps = HTMLAttributes<HTMLDivElement> & {
  close?: () => void;
  success?: () => void;
  // whether show close button
  showClose?: boolean;
  // display title
  title?: string;
  width?: string;
  // whether hide when click dialog outside modal
  clickModalHide?: boolean;
};

// custom a dragable dialog
const CustomDialog = (props: CustomDialogProps) => {
  const [open, setOpen] = useState(true);
  const { close, title, children, width = '600px', showClose = true, clickModalHide = false } = props;

  /**
   * methods
   */
  const internalCloseAction = () => {
    setOpen(false);
    close && close();
  };
  const dialogCloseAction = (event, reason) => {
    if (clickModalHide || reason !== 'backdropClick') {
      internalCloseAction();
    }
  };

  // limit width
  const LimitWidthDialog = useMemo(() => {
    return styled(Dialog)(() => ({
      '& .MuiDialog-paper': {
        maxWidth: 'none',
        width: width,
        margin: '0 auto',
      },
    }));
  }, [width]);

  return (
    <LimitWidthDialog open={open} fullWidth onClose={dialogCloseAction} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      {title && (
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Subscribe
        </DialogTitle>
      )}
      {showClose && (
        <IconButton className="absolute right-3 top-3 z-20 h-8 w-8 text-[#999]" aria-label="close" onClick={internalCloseAction}>
          <Close />
        </IconButton>
      )}
      <DialogContent>{children}</DialogContent>
    </LimitWidthDialog>
  );
};

export default CustomDialog;
